import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

import { NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX } from '~constants/filters';

const OutlinedIconButton = styled(IconButton)(({ theme }) => ({
  '&.MuiIconButton-root': {
    border: `solid 1px ${theme.brandV2.colors.treadGray7}`,
    borderRadius: theme.spacing(0.5),
    color: theme.brandV2.colors.treadBlack,
    height: `${NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX}px`,
    padding: '2px',
    width: `${NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX}px`,
  },
}));

export default OutlinedIconButton;
